module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/advantages_2_L5-7e970090ef28f5c7a3211e1bc2b7c60c.png";